// app/javascript/controllers/upload_preview_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "progressWrap", "progressBar", "name"];
  static values  = { maxSize: Number, types: String };

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("direct-upload:initialize", this.initProgress);
      this.inputTarget.addEventListener("direct-upload:progress", this.updateProgress);
      this.inputTarget.addEventListener("direct-upload:error", this.errorProgress);
      this.inputTarget.addEventListener("direct-upload:end", this.endProgress);
    }
  }
  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener("direct-upload:initialize", this.initProgress);
      this.inputTarget.removeEventListener("direct-upload:progress", this.updateProgress);
      this.inputTarget.removeEventListener("direct-upload:error", this.errorProgress);
      this.inputTarget.removeEventListener("direct-upload:end", this.endProgress);
    }
  }

  show = () => {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    // per-field validation
    const max = this.hasMaxSizeValue ? this.maxSizeValue : 5 * 1024 * 1024;
    if (file.size > max) { alert(`File too large (max ${(max/1024/1024)|0} MB).`); this.inputTarget.value = ""; return; }
    const allowed = this.hasTypesValue && this.typesValue ? this.typesValue.split(",").map(s=>s.trim()) : [];
    if (allowed.length && !allowed.includes(file.type)) { alert(`Invalid type: ${file.type}`); this.inputTarget.value = ""; return; }

    // PREVIEW: icon or image ONLY (no padding/text inside the tile)
    if (file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file);
      this.previewTarget.innerHTML = `<img src="${url}" width="50" alt="">`;
    } else if (file.type === "application/pdf") {
      this.previewTarget.innerHTML = `<i class="far fa-file-pdf" style="font-size:28px; line-height:1;"></i>`;
    } else {
      this.previewTarget.innerHTML = `<i class="far fa-file" style="font-size:24px; line-height:1;"></i>`;
    }

    // filename OUTSIDE the tile
    if (this.hasNameTarget) this.nameTarget.textContent = file.name;
  };

  initProgress = () => {
    if (this.hasProgressWrapTarget) this.progressWrapTarget.hidden = false;
    if (this.hasProgressBarTarget) this.progressBarTarget.style.width = "0%";
  };
  updateProgress = (e) => { if (this.hasProgressBarTarget) this.progressBarTarget.style.width = `${e.detail.progress}%`; };
  errorProgress  = () => { if (this.hasProgressBarTarget) this.progressBarTarget.classList.add("bg-danger"); };
  endProgress    = () => {
    if (this.hasProgressBarTarget) this.progressBarTarget.style.width = "100%";
    if (this.hasProgressWrapTarget) setTimeout(() => (this.progressWrapTarget.hidden = true), 500);
  };
}
